export type OrgInt = {
  id: string
  name: string
  type: OrganizationIntegrationType
  facebook?: {
    pixelId?: string
  }
  googleTagManager?: {
    containerId?: string
  }
}

export enum OrganizationIntegrationType {
  // BITLY = 'BITLY',
  INSIGHTLY = 'INSIGHTLY',
  MAILCHIMP = 'MAILCHIMP',
  // EVENTBRITE = 'EVENTBRITE',
  STRIPE = 'STRIPE',
  OMNIVORE = 'OMNIVORE',
  HELIOS = 'HELIOS',
  RPOWER = 'RPOWER',
  SILVERWARE = 'SILVERWARE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE_TAG_MANAGER = 'GOOGLE_TAG_MANAGER',
}
